import { render, staticRenderFns } from "./ProductinforNew.vue?vue&type=template&id=09a9c130&scoped=true"
import script from "./ProductinforNew.vue?vue&type=script&lang=js"
export * from "./ProductinforNew.vue?vue&type=script&lang=js"
import style0 from "./ProductinforNew.vue?vue&type=style&index=0&id=09a9c130&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a9c130",
  null
  
)

export default component.exports